module.exports = __webpack_public_path__ + "static/img/portIcon2.b86ac8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile_images/portIcon2.png
// module id = PZlm
// module chunks = 1